export const MODAL_DISMISSED_KEY = "_up-lead-capture-modal-dismissed";
export const SUCCESS_KEY = "_up-lead-capture-success";
export const EXCLUDED_PAGES = [
  "application",
  "apply-now",
  "checkout",
  "communication-settings",
  "express",
  "orders",
  "profile",
  "scholarship",
  "signin",
  "syllabus",
  "slice-simulator",
];

export const MODAL_DELAY = 5000;
